function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, Carousel, RED_500, Divider, getTestId, Highlight, InfoTag, isValidObject, Progress, Typography, useBreakpoint, WHITE, checkIsPlatform, Card } from '@airtel/air-design-system';
import { DotIndicator } from '@airtel/air-design-system/lib/components/carousel/components/dot-indicator';
import { useCallback, useRef } from 'react';
import { FlatList, Image, Pressable, View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { CalloutWidgetComponent } from '../callout-widget/CalloutWidget';
import { KeyPairUnitWidget } from '../key-pair-unit-widget';
import { LinkListItemWidget } from '../link-list-item-widget';
import { PriceBreakupWidgetComponent } from '../price-breakup-widget/PriceBreakupWidget';
import { SectionTitleWidget } from '../section-title-widget';
import { OverviewCardCollapsibleSection } from './components/collapsible-section/CollapsibleSection';
import { PlanInfoSection } from './components/over-view-card-plan-info-section/PlanInfoSection';
import { ComponentType } from './constants';
import { getOverViewCardWidgetStyles } from './OverViewCardWidgetStyles';
import ImageContainer from '../add-on-widget/components/image-contaier';
export var OverViewCardWidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'OverViewCardWidget' : _props$testID,
    style = props.style,
    _props$accessible = props.accessible,
    accessible = _props$accessible === void 0 ? false : _props$accessible,
    imageCarouselProps = props.imageCarouselProps,
    cardSectionTitleProps = props.cardSectionTitleProps,
    cardCtaProps = props.cardCtaProps,
    planInfoSectionProps = props.planInfoSectionProps,
    callOutProps = props.callOutProps,
    rowButtonWidgetProps = props.rowButtonWidgetProps,
    headerContainerStyle = props.headerContainerStyle,
    data = props.data,
    onUserAction = props.onUserAction,
    onCardPressMetaData = props.onCardPressMetaData,
    maxVisibleItems = props.maxVisibleItems,
    footerContainerStyle = props.footerContainerStyle,
    infoTags = props.infoTags,
    infoTagsContent = props.infoTagsContent,
    infoTagsStyle = props.infoTagsStyle,
    infoTagsContentStyle = props.infoTagsContentStyle,
    collapsibleProps = props.collapsibleProps,
    collapsibleSectionProps = props.collapsibleSectionProps,
    highLightProps = props.highLightProps,
    onTogglePressMetaData = props.onTogglePressMetaData,
    withCardWrapper = props.withCardWrapper,
    contentCardProps = props.contentCardProps;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var overViewCardWidgetStyles = getOverViewCardWidgetStyles();
  var setOfVisitedIds = useRef(new Set());
  var renderCarouselItem = useCallback(item => {
    return _jsx(Image, Object.assign({
      style: overViewCardWidgetStyles.carouselImageItem
    }, item));
  }, [overViewCardWidgetStyles.carouselImageItem]);
  var renderInfoTags = (infoTags, infoTagStyle) => {
    return _jsx(View, Object.assign({
      style: [overViewCardWidgetStyles.infoTagsContainerStyle, infoTagStyle]
    }, {
      children: infoTags.map((props, index) => (_createElement(InfoTag, Object.assign({}, props, {
        key: index + "+infotags"
      }))))
    }));
  };
  var renderHeaderComponent = () => {
    if (isValidObject(cardSectionTitleProps) || isValidObject(planInfoSectionProps) || isValidObject(infoTags)) {
      return _jsxs(View, Object.assign({
        style: [overViewCardWidgetStyles.headerContainerStyle, headerContainerStyle],
        testID: testID + '_headerComponent'
      }, {
        children: [!!isValidObject(infoTags) && (infoTags === null || infoTags === void 0 ? void 0 : infoTags.length) > 0 && renderInfoTags(infoTags, infoTagsStyle), !!isValidObject(cardSectionTitleProps) && _jsx(SectionTitleWidget, Object.assign({
          onUserAction: onUserAction,
          style: overViewCardWidgetStyles.cardSectionTitleStyle,
          testID: testID + '_headerComponent_sectionTitleWidget'
        }, cardSectionTitleProps)), !!isValidObject(cardCtaProps) && _jsx(ButtonWidget, Object.assign({
          onUserAction: onUserAction,
          testID: testID + '_headerComponent_buttonWidget'
        }, cardCtaProps)), !!isValidObject(planInfoSectionProps) && _jsx(PlanInfoSection, Object.assign({
          style: [overViewCardWidgetStyles.marginBottom16, planInfoSectionProps.style],
          onUserAction: onUserAction,
          testID: testID + '_headerComponent_planInfoSection'
        }, planInfoSectionProps))]
      }));
    }
    return null;
  };
  var getTypographyTypeAndColor = id => {
    switch (id) {
      case ComponentType.TYPOGRAPHY_HEADING:
        return {
          type: isSmallScreen ? 'body-para-lg-bold' : 'body-para-xl-bold',
          color: BLACK_900
        };
      case ComponentType.TYPOGRAPHY_SUB_TEXT:
        return {
          type: isSmallScreen ? 'body-para-sm' : 'body-para-md',
          color: BLACK_700
        };
      default:
        return {
          type: '',
          color: ''
        };
    }
  };
  var renderComponentById = _ref => {
    var item = _ref.item,
      index = _ref.index;
    var _a;
    if (item === null || item === void 0 ? void 0 : item.id) {
      var widgetStyle = [(item === null || item === void 0 ? void 0 : item.noBottomMargin) ? {
        marginBottom: 0
      } : overViewCardWidgetStyles.marginBottom16, (_a = item === null || item === void 0 ? void 0 : item.widgetProps) === null || _a === void 0 ? void 0 : _a.style];
      switch (item.id) {
        case ComponentType.LINK_LIST_ITEM_WIDGET:
          return _jsx(LinkListItemWidget, Object.assign({
            style: widgetStyle,
            onUserAction: onUserAction
          }, getTestId(testID + '_placeholderWidget_linkListItemWidget', index.toString()), item === null || item === void 0 ? void 0 : item.widgetProps));
        case ComponentType.KEY_PAIR_UNIT_WIDGET:
          return _jsx(KeyPairUnitWidget, Object.assign({
            style: widgetStyle,
            onUserAction: onUserAction
          }, getTestId(testID + '_placeholderWidget_keyPairUnitWidget', index.toString()), item === null || item === void 0 ? void 0 : item.widgetProps));
        case ComponentType.CALLOUT_WIDGET:
          return _jsx(CalloutWidgetComponent, Object.assign({
            style: widgetStyle,
            onUserAction: onUserAction
          }, getTestId(testID + '_placeholderWidget_calloutwidget', index.toString()), item === null || item === void 0 ? void 0 : item.widgetProps));
        case ComponentType.DIVIDER_WIDGET:
          return _jsx(Divider, Object.assign({
            style: widgetStyle,
            onUserAction: onUserAction
          }, getTestId(testID + '_placeholderWidget_dividerwidget', index.toString()), item === null || item === void 0 ? void 0 : item.widgetProps));
        case ComponentType.BUTTON_WIDGET:
          return _jsx(ButtonWidget, Object.assign({
            style: widgetStyle,
            onUserAction: onUserAction
          }, getTestId(testID + '_placeholderWidget_buttonWidget', index.toString()), item === null || item === void 0 ? void 0 : item.widgetProps));
        case ComponentType.PROGRESS_BAR_WIDGET:
          return _jsx(Progress, Object.assign({
            style: widgetStyle,
            onUserAction: onUserAction
          }, getTestId(testID + '_placeholderWidget_progressWidget', index.toString()), item === null || item === void 0 ? void 0 : item.widgetProps));
        case ComponentType.TYPOGRAPHY_HEADING:
        case ComponentType.TYPOGRAPHY_SUB_TEXT:
          return _jsx(Typography, Object.assign({
            style: widgetStyle,
            onUserAction: onUserAction
          }, getTypographyTypeAndColor(item.id), getTestId(testID + '_placeholderWidget_typographyWidget', index.toString()), item === null || item === void 0 ? void 0 : item.widgetProps));
        case ComponentType.PRICE_BREAKUP_WIDGET:
          return _jsx(PriceBreakupWidgetComponent, Object.assign({
            style: widgetStyle,
            onUserAction: onUserAction
          }, getTestId(testID + '_placeholderWidget_priceBreakupWidget', index.toString()), item === null || item === void 0 ? void 0 : item.widgetProps));
        case ComponentType.IMAGE_CONTAINER_WIDGET:
          return _jsx(ImageContainer, Object.assign({
            style: widgetStyle,
            isLargeScreen: !isSmallScreen,
            onUserAction: onUserAction
          }, getTestId(testID + '_placeholderWidget_imageContainerWidget', index.toString()), item === null || item === void 0 ? void 0 : item.widgetProps));
        default:
          return _jsx(_Fragment, {});
      }
    }
    return _jsx(_Fragment, {});
  };
  var renderListFooterComponent = () => {
    if (isValidObject(callOutProps) || isValidObject(rowButtonWidgetProps) || isValidObject(highLightProps)) {
      return _jsxs(_Fragment, {
        children: [_jsxs(View, Object.assign({
          style: [overViewCardWidgetStyles.footerContainerStyle, footerContainerStyle]
        }, {
          children: [!!isValidObject(callOutProps) && _jsx(CalloutWidgetComponent, Object.assign({
            style: [overViewCardWidgetStyles.marginBottom16, callOutProps.style],
            onUserAction: onUserAction
          }, getTestId(testID + '_calloutwidget'), callOutProps)), !!isValidObject(rowButtonWidgetProps) && _jsx(ButtonWidget, Object.assign({
            style: [overViewCardWidgetStyles.marginBottom16, rowButtonWidgetProps.style],
            onUserAction: onUserAction
          }, getTestId(testID + '_buttonwidget'), rowButtonWidgetProps))]
        })), !!isValidObject(highLightProps) && _jsx(Highlight, Object.assign({}, getTestId(testID + '_highlight'), highLightProps))]
      });
    }
    return null;
  };
  var renderIndicators = props => {
    var _a;
    if (((_a = imageCarouselProps === null || imageCarouselProps === void 0 ? void 0 : imageCarouselProps.data) === null || _a === void 0 ? void 0 : _a.length) > 1) {
      return _jsx(DotIndicator, Object.assign({
        activeColor: RED_500,
        inActiveColor: WHITE,
        dotStyle: overViewCardWidgetStyles.dotIndicatorStyle
      }, props));
    }
    return null;
  };
  var onCardPress = () => {
    onCardPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onCardPressMetaData), props));
  };
  var onViewableItemsChanged = useCallback(info => {
    var _a, _b, _c, _d, _e;
    for (var _iterator = _createForOfIteratorHelperLoose((_a = info === null || info === void 0 ? void 0 : info.viewableItems) !== null && _a !== void 0 ? _a : []), _step; !(_step = _iterator()).done;) {
      var viewableItem = _step.value;
      var sendImpression = checkIsPlatform('web') && !((_b = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _b === void 0 ? void 0 : _b.has(viewableItem === null || viewableItem === void 0 ? void 0 : viewableItem.index));
      if ((viewableItem === null || viewableItem === void 0 ? void 0 : viewableItem.index) != null) {
        sendImpression && ((_c = setOfVisitedIds === null || setOfVisitedIds === void 0 ? void 0 : setOfVisitedIds.current) === null || _c === void 0 ? void 0 : _c.add(viewableItem === null || viewableItem === void 0 ? void 0 : viewableItem.index));
        ((_d = viewableItem === null || viewableItem === void 0 ? void 0 : viewableItem.item) === null || _d === void 0 ? void 0 : _d.onItemImpression) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, (_e = viewableItem === null || viewableItem === void 0 ? void 0 : viewableItem.item) === null || _e === void 0 ? void 0 : _e.onItemImpression), viewableItem === null || viewableItem === void 0 ? void 0 : viewableItem.item));
      }
    }
  }, []);
  var keyExtractor = (item, index) => item.id + "-" + index;
  var renderPlaceHolderWithIndex = (startIndex, endIndex) => {
    return _jsx(View, Object.assign({
      style: overViewCardWidgetStyles.horizontalPadding16
    }, {
      children: _jsx(FlatList, {
        data: data.slice(startIndex, endIndex),
        renderItem: renderComponentById,
        keyExtractor: keyExtractor,
        onViewableItemsChanged: onViewableItemsChanged
      })
    }));
  };
  var overViewCardCollapsibleFlag = (data === null || data === void 0 ? void 0 : data.length) > 0 && maxVisibleItems > 0 && (data === null || data === void 0 ? void 0 : data.length) - maxVisibleItems > 1;
  var renderContent = () => {
    var content = _jsxs(_Fragment, {
      children: [!!isValidObject(infoTagsContent) && (infoTagsContent === null || infoTagsContent === void 0 ? void 0 : infoTagsContent.length) > 0 && renderInfoTags(infoTagsContent, infoTagsContentStyle), (data === null || data === void 0 ? void 0 : data.length) > 0 && renderPlaceHolderWithIndex(0, maxVisibleItems ? maxVisibleItems : data === null || data === void 0 ? void 0 : data.length), overViewCardCollapsibleFlag && _jsx(OverviewCardCollapsibleSection, Object.assign({
        onUserAction: onUserAction,
        onTogglePressMetaData: onTogglePressMetaData,
        collapsibleProps: collapsibleProps,
        testID: testID + '_overviewCardCollapsibleSection'
      }, collapsibleSectionProps, {
        children: renderPlaceHolderWithIndex(maxVisibleItems, data.length)
      })), renderListFooterComponent()]
    });
    return content;
  };
  return _jsxs(Pressable, Object.assign({
    accessible: accessible,
    onPress: onCardPress
  }, getTestId(testID), {
    style: [style]
  }, {
    children: [!!isValidObject(imageCarouselProps) && _jsx(Carousel, Object.assign({
      data: imageCarouselProps === null || imageCarouselProps === void 0 ? void 0 : imageCarouselProps.data,
      renderItem: renderCarouselItem,
      indicator: renderIndicators,
      testID: testID + '_carousel'
    }, imageCarouselProps)), renderHeaderComponent(), withCardWrapper ? _jsx(Card, Object.assign({}, contentCardProps, {
      children: renderContent()
    })) : renderContent()]
  }));
};
OverViewCardWidgetComponent.genericRendererKey = 'AirOverViewCardWidget';